import { Label } from '@kanda-libs/ks-component-ts';
import { Icon } from '@kanda-libs/ks-design-library';
import Rate from './Rate';
import useAPRs from './useAPRs';

const APRs: React.FunctionComponent = function () {
  const { isLoading, grouped, workTypeSelected, keys } = useAPRs();
  if (!isLoading && !workTypeSelected)
    return (
      <div className="flex flex-row text-left px-4 py-3 bg-orange-100 border border-orange-200 rounded-lg mb-5">
        <Icon
          icon="error"
          size={20}
          className="my-auto mr-2 min-w-5"
          stroke="orange-200"
        />
        <p className="text-13-14-em text-orange-200">
          Select a work type above to see finance options
        </p>
      </div>
    );
  if (!grouped)
    return (
      <div className="flex flex-col text-left mb-5">
        <Label label="No Eligible APRS" isLoading={isLoading} />
      </div>
    );
  return (
    <div className="flex flex-col text-left mb-5">
      <Label label="Eligible APRs" isLoading={isLoading} />
      <div className="flex flex-col gap-y-3 mt-2">
        {keys.map((apr: string) => (
          <Rate
            key={apr}
            rates={grouped[apr]}
            apr={apr}
            isLoading={isLoading}
          />
        ))}
      </div>
    </div>
  );
};

export default APRs;
